import type { OrgIntelligenceProofLevelDto } from './org-intelligence-ontology';

export const VCB_ECONOMIC_TYPES = [
  'revenue',
  'gross_margin',
  'sgna',
  'opex',
  'cash',
  'working_capital',
  'risk_avoidance',
] as const;

export type VcbEconomicTypeDto = (typeof VCB_ECONOMIC_TYPES)[number];

export type BlueprintRunClaimProofLevelDto = OrgIntelligenceProofLevelDto;

export type VcbMetricValueDto = {
  value: number | null;
  unit: string;
  scope: string;
  timeframe: string;
  source: string;
  asOf: string | null;
};

export type VcbEconomicClaimDto = {
  claimId: string;
  economicType: VcbEconomicTypeDto;
  baseline: VcbMetricValueDto;
  delta: VcbMetricValueDto | null;
  confidenceBand: {
    low: number | null;
    high: number | null;
    unit: string;
  } | null;
  proofLevel: BlueprintRunClaimProofLevelDto;
  sourceRefs: string[];
  calculationRule: string;
  attributionRule: string;
  reconciliationRule: string;
  ownerUserId: string | null;
  impactIfWrong: string;
};

export type VcbEconomicDriverTreeDto = {
  treeId: string;
  strategicObjectiveId: string;
  baselineAsOf: string | null;
  currency: string;
  claims: VcbEconomicClaimDto[];
  residuals: Array<{
    residualId: string;
    label: string;
    value: VcbMetricValueDto;
    reason: string;
  }>;
  doubleCountChecks: Array<{
    checkId: string;
    status: 'passed' | 'failed' | 'unknown';
    details: string;
  }>;
};

export type BlueprintRunPressureTestPersonaDto =
  | 'ceo'
  | 'cfo'
  | 'coo'
  | 'chro'
  | 'board'
  | 'operating_review'
  | 'governance_security';

export type BlueprintRunPressureTestGateDto =
  | 'none'
  | 'blocks_recommendation'
  | 'blocks_review_ready'
  | 'blocks_activation';

export type BlueprintRunPressureTestRuleDto = {
  ruleId: string;
  persona: BlueprintRunPressureTestPersonaDto;
  triggerCondition: string;
  challengeText: string;
  gate: BlueprintRunPressureTestGateDto;
  requiredWhen: string;
};

export type BlueprintRunPressureTestItemDto = {
  itemId: string;
  ruleId: string;
  persona: BlueprintRunPressureTestPersonaDto;
  triggerCondition: string;
  challengeText: string;
  linkedClaimIds: string[];
  linkedEvidenceRefs: string[];
  linkedGapIds: string[];
  recommendedLeadershipAction: 'commit' | 'amend' | 'defer' | 'escalate' | 'reject';
  gate: BlueprintRunPressureTestGateDto;
  status: 'open' | 'accepted_risk' | 'resolved' | 'blocked';
};
